var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "addFormBox" }, [
        _c(
          "div",
          { staticClass: "basicForm" },
          [
            _c(
              "div",
              { staticClass: "title feet-r" },
              [
                _vm._v(" " + _vm._s(_vm.$t("basicData.UnderlyingData")) + " "),
                _vm.formData.discountStatus &&
                [0, 8].includes(_vm.formData.businessType) &&
                _vm.formData.id &&
                _vm.operationType === 2
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { type: "danger", size: "mini" },
                        on: { click: _vm.addBasicData },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("basicData.DiscountFactorMaintenance")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-form",
              {
                key: _vm.exportKey,
                ref: "queryForm",
                staticClass: "queryFormClass",
                attrs: {
                  model: _vm.formData,
                  rules: _vm.rules,
                  "label-position": "top",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "basicData.TheNameOfTheQuoteProposal"
                              ),
                              prop: "name",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("orderDetails.pleaseInput"),
                                clearable: "",
                                maxlength: "100",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formData.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "basicData.TheValidityPeriodBegins"
                              ),
                              prop: "startTime",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.isDataDisabled,
                                format: _vm.isZh,
                                placeholder: _vm.$t(
                                  "basicData.SelectADatetime"
                                ),
                                type: "datetime",
                                "picker-options": _vm.pickerOptions,
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.formData.startTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "startTime", $$v)
                                },
                                expression: "formData.startTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.businessT"),
                              prop: "businessType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeBusinessType(1)
                                  },
                                },
                                model: {
                                  value: _vm.formData.businessType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "businessType", $$v)
                                  },
                                  expression: "formData.businessType",
                                },
                              },
                              _vm._l(_vm.BUSINESS_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.formData.businessType === 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("basicData.CollectionType"),
                                  prop: "collectionCategory",
                                  rules: {
                                    required: _vm.formData.businessType === 1,
                                    message: _vm.$t("basicData.CannotBeEmpty"),
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      filterable: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeBusinessType(2)
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.collectionCategory,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "collectionCategory",
                                          $$v
                                        )
                                      },
                                      expression: "formData.collectionCategory",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.OrdinaryPickUp"
                                        ),
                                        value: 0,
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.StockingAndPickup"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.businessType !== 8
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "basicData.PartitionSchemeName"
                                  ),
                                  prop: "partitionId",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      filterable: "",
                                    },
                                    on: { change: _vm.getOtherFeeDetail },
                                    model: {
                                      value: _vm.formData.partitionId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "partitionId",
                                          $$v
                                        )
                                      },
                                      expression: "formData.partitionId",
                                    },
                                  },
                                  _vm._l(_vm.partitionList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("basicData.QuoteType"),
                              prop: "offerType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("basicData.PleaseSelect"),
                                },
                                on: { change: _vm.offerTypeChange },
                                model: {
                                  value: _vm.formData.offerType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "offerType", $$v)
                                  },
                                  expression: "formData.offerType",
                                },
                              },
                              _vm._l(_vm.QUOTE_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                    disabled: _vm.isOptionDisabled(
                                      item.value,
                                      1
                                    ),
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.quotationMode"),
                              prop: "offerMode",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("basicData.PleaseSelect"),
                                },
                                model: {
                                  value: _vm.formData.offerMode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "offerMode", $$v)
                                  },
                                  expression: "formData.offerMode",
                                },
                              },
                              _vm._l(_vm.QUOTE_MODE_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                    disabled: _vm.isOptionDisabled(
                                      item.value,
                                      2
                                    ),
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    [2, 3].includes(_vm.formData.offerType) &&
                    _vm.formData.businessType !== 8
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("basicData.businessPrincipal"),
                                  prop: "providerInfoId",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "spareNumberPoo.Only10AreDisplayed"
                                      ),
                                      "remote-method": _vm.queryProviderPage,
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      clearable: "",
                                    },
                                    on: {
                                      clear: _vm.queryProviderPage,
                                      change: _vm.providerInfoChange,
                                    },
                                    model: {
                                      value: _vm.formData.providerInfoId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "providerInfoId",
                                          $$v
                                        )
                                      },
                                      expression: "formData.providerInfoId",
                                    },
                                  },
                                  _vm._l(_vm.providerList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.providerBody +
                                          "（" +
                                          item.providerName +
                                          "）（" +
                                          item.code +
                                          "）",
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    [4, 5].includes(_vm.formData.offerType)
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("receivablePayable.customer"),
                                  prop: "customerIds",
                                  rules: {
                                    required: _vm.formData.offerType === 4,
                                    message: _vm.$t("basicData.CannotBeEmpty"),
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      multiple: !_vm.editData.id,
                                      placeholder: _vm.$t(
                                        "spareNumberPoo.Only10AreDisplayed"
                                      ),
                                      "remote-method": _vm.getCustomerPage,
                                      clearable: "",
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      "collapse-tags": "",
                                    },
                                    on: {
                                      clear: _vm.getCustomerPage,
                                      change: _vm.customerChange,
                                    },
                                    model: {
                                      value: _vm.formData.customerIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "customerIds",
                                          $$v
                                        )
                                      },
                                      expression: "formData.customerIds",
                                    },
                                  },
                                  _vm._l(
                                    _vm.customerList,
                                    function (item, ind) {
                                      return _c("el-option", {
                                        key: ind,
                                        attrs: {
                                          label:
                                            "" +
                                            (_vm.formData.businessType === 8
                                              ? ""
                                              : item.customerAlias) +
                                            "(" +
                                            item.username +
                                            ")",
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    [6].includes(_vm.formData.offerType)
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CenterForSorting.channel"),
                                  prop: "channelValue",
                                  rules: {
                                    required: true,
                                    message: _vm.$t("basicData.CannotBeEmpty"),
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "operationCenter.PleaseSelect"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.channelValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "channelValue",
                                          $$v
                                        )
                                      },
                                      expression: "formData.channelValue",
                                    },
                                  },
                                  _vm._l(_vm.channelList, function (item, ind) {
                                    return _c("el-option", {
                                      key: ind,
                                      attrs: {
                                        label:
                                          "" +
                                          item.dictName +
                                          "(" +
                                          item.dictValue +
                                          ")",
                                        value: item.dictValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.businessType !== 8
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("newOrder.TypeService"),
                                  prop: "expressType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      filterable: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.expressType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "expressType",
                                          $$v
                                        )
                                      },
                                      expression: "formData.expressType",
                                    },
                                  },
                                  _vm._l(_vm.EXPRESS_TYPE, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.name,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.businessType !== 8
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("placeOrder.cargoType"),
                                  prop: "cargoType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      filterable: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.cargoType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cargoType", $$v)
                                      },
                                      expression: "formData.cargoType",
                                    },
                                  },
                                  _vm._l(_vm.CARGO_TYPE, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.billType"),
                              prop: "billType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("basicData.PleaseSelect"),
                                  filterable: "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData.billType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "billType", $$v)
                                  },
                                  expression: "formData.billType",
                                },
                              },
                              _vm._l(_vm.BILL_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.name,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.formData.businessType === 0
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.lanshouTypee"
                                  ),
                                },
                              },
                              [
                                _c("CollectTypeCmp", {
                                  attrs: {
                                    value: _vm.formData.collectType,
                                    "business-type": 0,
                                  },
                                  on: {
                                    change: function (val) {
                                      return (_vm.formData.collectType = val)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    [0, 8].includes(_vm.formData.businessType)
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("basicData.DiscountFactor"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.discountStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "discountStatus",
                                          $$v
                                        )
                                      },
                                      expression: "formData.discountStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.DISCOUNT_COEFFICIENT,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.name,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("basicData.PriceDetails"))),
        ]),
        _vm.formData.businessType !== 8 && _vm.formData.partitionId
          ? _c(
              "div",
              { staticClass: "mb10 flex" },
              [
                _c(
                  "label",
                  {
                    staticClass: "el-form-item__label",
                    staticStyle: { width: "120px", "line-height": "32px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("basicData.PartitionName")) + "：")]
                ),
                _c("QueryPartVCmp", {
                  staticStyle: { width: "400px" },
                  attrs: {
                    val: _vm.formData.partitionAffiliateId,
                    list: _vm.subregionList,
                  },
                  on: {
                    change: function (val) {
                      return (_vm.formData.partitionAffiliateId = val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.formData.businessType === 8
          ? _c(
              "div",
              { staticClass: "mb10 flex" },
              [
                _c(
                  "label",
                  {
                    staticClass: "el-form-item__label",
                    staticStyle: { width: "120px", "line-height": "32px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("vehicle.modelLabel")) + "：")]
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "400px" },
                    attrs: {
                      placeholder: _vm.$t("basicData.PleaseSelect"),
                      size: "small",
                    },
                    model: {
                      value: _vm.formData.partitionAffiliateId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "partitionAffiliateId", $$v)
                      },
                      expression: "formData.partitionAffiliateId",
                    },
                  },
                  _vm._l(_vm.modelList, function (item) {
                    return _c("el-option", {
                      key: item.dictValue,
                      attrs: { label: item.dictLabel, value: item.dictValue },
                    })
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "priceTableForm" },
          [
            _c(
              "div",
              { staticClass: "feet-r mb10" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value: "btn:finance:basicData:quotationManagement:add",
                        expression:
                          "'btn:finance:basicData:quotationManagement:add'",
                        arg: "remove",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAdd()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("basicData.AddARow")) + " ")]
                ),
                _c(
                  "el-popover",
                  { attrs: { placement: "bottom-start", trigger: "hover" } },
                  [
                    _c("import-download", {
                      key: _vm.exportKey,
                      attrs: {
                        "expense-type-list": _vm.expenseTypeList,
                        "import-type": 1,
                        "table-data": {
                          formData: _vm.formData,
                          subregionList: _vm.subregionList,
                          modelList: _vm.modelList,
                        },
                        "table-data-obj": _vm.tableDataObj.collectFeesList,
                      },
                      on: { importPartition: _vm.importPartition },
                    }),
                    _c(
                      "template",
                      { slot: "reference" },
                      [
                        _c(
                          "el-button",
                          { attrs: { plain: "", size: "small" } },
                          [_vm._v(_vm._s(_vm.$t("basicData.ImportDownload")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _c(
                  "el-popover",
                  { attrs: { placement: "bottom-start", trigger: "hover" } },
                  [
                    _c(
                      "div",
                      { staticClass: "feet" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.clearOffers(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("basicData.EmptyCurrentPartition")
                              ) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "feet-btn",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.clearOffers(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("basicData.EmptyAllPartitions")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "template",
                      { slot: "reference" },
                      [
                        _c(
                          "el-button",
                          { attrs: { plain: "", size: "small" } },
                          [_vm._v(_vm._s(_vm.$t("basicData.ClearTheOffer")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "tableForm1",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.formData,
                  "label-width": "0px",
                  size: "small",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "el-table",
                      {
                        key: _vm.tableKey,
                        staticClass: "error-table",
                        attrs: {
                          data: _vm.formData.collectFeesList,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.ExpenseType"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("basicData.ExpenseType"))
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "collectFeesList." +
                                          scope.$index +
                                          ".feeTypeCode",
                                        rules: {
                                          required: true,
                                          message: _vm.$t(
                                            "basicData.CannotBeEmpty"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "basicData.PleaseSelect"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.chargeTypeChange(scope)
                                            },
                                          },
                                          model: {
                                            value: scope.row.feeTypeCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "feeTypeCode",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.feeTypeCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.expenseTypeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.displayName,
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        [0, 2].includes(_vm.formData.businessType) &&
                        _vm.formData.offerMode === 1
                          ? [
                              _c("el-table-column", {
                                attrs: { "min-width": "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "receivablePayable.weightType"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "collectFeesList." +
                                                  scope.$index +
                                                  ".weightType",
                                                rules: {
                                                  required: true,
                                                  message: _vm.$t(
                                                    "basicData.CannotBeEmpty"
                                                  ),
                                                  trigger: ["blur", "change"],
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "basicData.PleaseSelect"
                                                    ),
                                                  },
                                                  model: {
                                                    value: scope.row.weightType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "weightType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.weightType",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "receivablePayable.initialWeight"
                                                      ),
                                                      value: 0,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "receivablePayable.renewWeight"
                                                      ),
                                                      value: 1,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2356655579
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { "min-width": "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "receivablePayable.weightStart"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "collectFeesList." +
                                                  scope.$index +
                                                  ".startWeight",
                                                rules: {
                                                  required: true,
                                                  negative: "",
                                                  suffix: 3,
                                                  negative1: 1,
                                                  package: scope.row.endWeight,
                                                  validator: _vm.priceType,
                                                  trigger: ["blur", "change"],
                                                },
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value: scope.row.startWeight,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "startWeight",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.startWeight",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1054616256
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { "min-width": "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "receivablePayable.continuedWeightEnd"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "collectFeesList." +
                                                  scope.$index +
                                                  ".endWeight",
                                                rules: {
                                                  required: true,
                                                  negative: "",
                                                  suffix: 3,
                                                  negative1: 2,
                                                  package:
                                                    scope.row.startWeight,
                                                  validator: _vm.priceType,
                                                  trigger: ["blur", "change"],
                                                },
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value: scope.row.endWeight,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "endWeight",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.endWeight",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3397884262
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("basicData.Price"),
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("basicData.Price")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "collectFeesList." +
                                                  scope.$index +
                                                  ".price",
                                                rules: {
                                                  required: true,
                                                  suffix: 2,
                                                  negative: "",
                                                  validator: _vm.priceType,
                                                  trigger: ["blur", "change"],
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        flex: "1",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            scope.row.price,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "price",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.price",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "35px",
                                                        "text-align": "right",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "/" +
                                                          _vm._s(
                                                            scope.row
                                                              .weightType === 1
                                                              ? "KG"
                                                              : _vm.$t(
                                                                  "basicData.ticket"
                                                                )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2502220480
                                ),
                              }),
                            ]
                          : [
                              _vm.formData.collectionCategory !== 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("basicData.chargeType"),
                                      "min-width": "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "basicData.chargeType"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "collectFeesList." +
                                                      scope.$index +
                                                      ".billingType",
                                                    rules: {
                                                      required:
                                                        !_vm.formData
                                                          .collectionCategory,
                                                      message: _vm.$t(
                                                        "basicData.CannotBeEmpty"
                                                      ),
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "basicData.PleaseSelect"
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.chargeTypeChange(
                                                            scope
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.billingType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "billingType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.billingType",
                                                      },
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.formData
                                                                .businessType !==
                                                              8,
                                                            expression:
                                                              "formData.businessType !== 8",
                                                          },
                                                        ],
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "newOperationCenter.Weight"
                                                          ),
                                                          value: 1,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.formData
                                                                .businessType !==
                                                              8,
                                                            expression:
                                                              "formData.businessType !== 8",
                                                          },
                                                        ],
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "collectionCenter.ballot"
                                                          ),
                                                          value: 2,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.formData
                                                                .businessType ===
                                                              8,
                                                            expression:
                                                              "formData.businessType === 8",
                                                          },
                                                        ],
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "collectionCenter.distance"
                                                          ),
                                                          value: 4,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1305650508
                                    ),
                                  })
                                : _vm._e(),
                              _vm.formData.businessType === 1 &&
                              _vm.formData.collectionCategory === 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.lanshouTypee"
                                      ),
                                      "min-width": "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("div", [
                                                _vm.formData.businessType === 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [_vm._v("*")]
                                                    )
                                                  : _vm._e(),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "collectionCenter.lanshouTypee"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "collectFeesList." +
                                                      scope.$index +
                                                      ".collectType",
                                                    rules: {
                                                      required: true,
                                                      message: _vm.$t(
                                                        "basicData.CannotBeEmpty"
                                                      ),
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "basicData.PleaseSelect"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.collectType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "collectType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.collectType",
                                                      },
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        key: 1,
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "collectionCenter.dropOff"
                                                          ),
                                                          value: 1,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        key: 2,
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "collectionCenter.doorPickUp"
                                                          ),
                                                          value: 2,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      302950034
                                    ),
                                  })
                                : _vm._e(),
                              _vm.formData.collectionCategory === 1
                                ? [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.BoxCountStartsNotIncluded"
                                        ),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.BoxCountStartsNotIncluded"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "collectFeesList." +
                                                        scope.$index +
                                                        ".startCases",
                                                      rules: {
                                                        required: true,
                                                        negative: "",
                                                        suffix: 2,
                                                        negative1: 1,
                                                        package:
                                                          scope.row.endCases,
                                                        validator: _vm.Integer0,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          scope.row.startCases,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "startCases",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.startCases",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1816057505
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.EndOfCaseCountIncluded"
                                        ),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.EndOfCaseCountIncluded"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "collectFeesList." +
                                                        scope.$index +
                                                        ".endCases",
                                                      rules: {
                                                        required: true,
                                                        negative: "",
                                                        suffix: 2,
                                                        negative1: 2,
                                                        package:
                                                          scope.row.startCases,
                                                        validator: _vm.Integer0,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          scope.row.endCases,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "endCases",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.endCases",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3360074476
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("basicData.Price"),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.Price"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "collectFeesList." +
                                                        scope.$index +
                                                        ".price",
                                                      rules: {
                                                        required: true,
                                                        suffix: 2,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value: scope.row.price,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "price",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.price",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3271538086
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.ExceedingThePrice"
                                        ),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "basicData.ExceedingThePrice"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "collectFeesList." +
                                                        scope.$index +
                                                        ".overExtraPrice",
                                                      rules: {
                                                        required: false,
                                                        suffix: 2,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .overExtraPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "overExtraPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.overExtraPrice",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2923618650
                                      ),
                                    }),
                                  ]
                                : [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("basicData.Begin"),
                                        "min-width": "240",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.Begin")
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.billingType === 2
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            prop:
                                                              "collectFeesList." +
                                                              scope.$index +
                                                              ".startWeight",
                                                            rules: {
                                                              required: false,
                                                              negative: "",
                                                              suffix: 2,
                                                              negative1: 1,
                                                              package:
                                                                scope.row
                                                                  .endWeight,
                                                              validator:
                                                                _vm.priceType,
                                                              trigger: [
                                                                "blur",
                                                                "change",
                                                              ],
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-input",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          scope
                                                                            .row
                                                                            .startWeight,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              scope.row,
                                                                              "startWeight",
                                                                              typeof $$v ===
                                                                                "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "scope.row.startWeight",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    "text-align":
                                                                      "right",
                                                                  },
                                                                },
                                                                [_vm._v("(KG)")]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            prop:
                                                              "collectFeesList." +
                                                              scope.$index +
                                                              ".startWeight",
                                                            rules: {
                                                              required: true,
                                                              negative: "",
                                                              suffix: 3,
                                                              negative1: 1,
                                                              package:
                                                                scope.row
                                                                  .endWeight,
                                                              validator:
                                                                _vm.priceType,
                                                              trigger: [
                                                                "blur",
                                                                "change",
                                                              ],
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-input",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          scope
                                                                            .row
                                                                            .startWeight,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              scope.row,
                                                                              "startWeight",
                                                                              typeof $$v ===
                                                                                "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "scope.row.startWeight",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    "text-align":
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      scope.row
                                                                        .billingType ===
                                                                        4
                                                                        ? "(KM)"
                                                                        : "(KG)"
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("basicData.end"),
                                        "min-width": "240",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.end")
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.billingType === 2
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            prop:
                                                              "collectFeesList." +
                                                              scope.$index +
                                                              ".endWeight",
                                                            rules: {
                                                              required: false,
                                                              negative: "",
                                                              suffix: 2,
                                                              negative1: 2,
                                                              package:
                                                                scope.row
                                                                  .startWeight,
                                                              validator:
                                                                _vm.priceType,
                                                              trigger: [
                                                                "blur",
                                                                "change",
                                                              ],
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-input",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          scope
                                                                            .row
                                                                            .endWeight,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              scope.row,
                                                                              "endWeight",
                                                                              typeof $$v ===
                                                                                "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "scope.row.endWeight",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    "text-align":
                                                                      "right",
                                                                  },
                                                                },
                                                                [_vm._v("(KG)")]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            prop:
                                                              "collectFeesList." +
                                                              scope.$index +
                                                              ".endWeight",
                                                            rules: {
                                                              required: true,
                                                              negative: "",
                                                              suffix: 3,
                                                              negative1: 2,
                                                              package:
                                                                scope.row
                                                                  .startWeight,
                                                              validator:
                                                                _vm.priceType,
                                                              trigger: [
                                                                "blur",
                                                                "change",
                                                              ],
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-input",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          scope
                                                                            .row
                                                                            .endWeight,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              scope.row,
                                                                              "endWeight",
                                                                              typeof $$v ===
                                                                                "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "scope.row.endWeight",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    "text-align":
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      scope.row
                                                                        .billingType ===
                                                                        4
                                                                        ? "(KM)"
                                                                        : "(KG)"
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("basicData.Price"),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.Price")
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "collectFeesList." +
                                                      scope.$index +
                                                      ".price",
                                                    rules: _vm.rules.price,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            model: {
                                                              value:
                                                                scope.row.price,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "price",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.price",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      scope.row.billingType ===
                                                      2
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "right",
                                                              },
                                                              style: {
                                                                width:
                                                                  _vm.$i18n
                                                                    .locale !==
                                                                  "zh"
                                                                    ? "50px"
                                                                    : "25px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " /" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "basicData.ticket"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t(
                                          "basicData.ExceedingThePrice"
                                        ),
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "basicData.ExceedingThePrice"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "collectFeesList." +
                                                      scope.$index +
                                                      ".overWeightExtraPrice",
                                                    rules:
                                                      _vm.rules
                                                        .overWeightExtraPrice,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .overWeightExtraPrice,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "overWeightExtraPrice",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.overWeightExtraPrice",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "35px",
                                                            "text-align":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .billingType ===
                                                                4
                                                                ? "/KM"
                                                                : "/KG"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                            ],
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.operate"),
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-popconfirm", {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.AreYouSureYouWantToDelete"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handleDel(
                                          scope.$index,
                                          "collectFeesList"
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "danger",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("basicData.Delete")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "feet-r mb10" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:finance:basicData:quotationManagement:add",
                                expression:
                                  "'btn:finance:basicData:quotationManagement:add'",
                                arg: "remove",
                              },
                            ],
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAdd1()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("basicData.AddAdditionalRules")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "hover",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "reference",
                                fn: function () {
                                  return [
                                    _c(
                                      "el-button",
                                      { attrs: { plain: "", size: "small" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.ImportDownload")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _c("import-download", {
                              key: _vm.exportKey,
                              attrs: {
                                "import-type": 2,
                                "expense-type-list": _vm.expenseTypeList,
                                "special-fee-list": _vm.specialFeeList,
                                "insurance-type-list": _vm.insuranceTypeList,
                                "other-rules-raw-data": _vm.otherRulesRawData,
                                "table-data": {
                                  formData: _vm.formData,
                                  subregionList: _vm.subregionList,
                                  modelList: _vm.modelList,
                                },
                                "table-data-obj":
                                  _vm.tableDataObj.collectFeesList,
                              },
                              on: { importPartition: _vm.importPartition },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "hover",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "reference",
                                fn: function () {
                                  return [
                                    _c(
                                      "el-button",
                                      { attrs: { plain: "", size: "small" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.ClearTheOffer")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "feet" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearOtherOffers(1)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "basicData.EmptyCurrentPartition"
                                        )
                                      ) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "feet-btn",
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearOtherOffers(2)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("basicData.EmptyAllPartitions")
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        key: _vm.tableKey,
                        staticClass: "error-table",
                        attrs: { data: _vm.formData.feeTypeList, border: "" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.ExpenseType"),
                            width: "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("basicData.ExpenseType"))
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "feeTypeList." +
                                              scope.$index +
                                              ".feeTypeCode",
                                            rules: {
                                              required: true,
                                              message: _vm.$t(
                                                "basicData.CannotBeEmpty"
                                              ),
                                              trigger: ["blur", "change"],
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "basicData.PleaseSelect"
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.feeTypeCodeChange(
                                                    scope.row.feeTypeCode,
                                                    scope.$index
                                                  )
                                                },
                                                focus: function ($event) {
                                                  return _vm.disabledFeeTyp(
                                                    scope
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.feeTypeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "feeTypeCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.feeTypeCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.specialFeeList,
                                              function (item, ind) {
                                                return _c("el-option", {
                                                  key: ind,
                                                  attrs: {
                                                    disabled:
                                                      _vm.selectFeeTypeCode.includes(
                                                        item.code
                                                      ),
                                                    label: item.displayName,
                                                    value: item.code,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: _vm.$t("basicData.BillingRules") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    [0, 9, 14].includes(scope.row.specialRules)
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRate",
                                                    rules: {
                                                      required: true,
                                                      validator:
                                                        _vm.validateRange001To100,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row
                                                          .specialRules === 9
                                                          ? _vm.$t(
                                                              "basicData.invoiceAmount"
                                                            )
                                                          : scope.row
                                                              .specialRules ===
                                                            14
                                                          ? _vm.formData
                                                              .businessType
                                                            ? _vm.formData
                                                                .businessType ===
                                                              1
                                                              ? _vm.$t(
                                                                  "receivablePayable.CollectionFeeByFY003"
                                                                )
                                                              : _vm.formData
                                                                  .businessType ===
                                                                2
                                                              ? _vm.$t(
                                                                  "receivablePayable.DeliveryFeeByFY004"
                                                                )
                                                              : _vm.$t(
                                                                  "receivablePayable.TransportationFeeByFY035"
                                                                )
                                                            : _vm.$t(
                                                                "receivablePayable.CalculateByFY001ExpressFee"
                                                              )
                                                          : _vm.$t(
                                                              "basicData.TheAmountDeclaredForTheProduct"
                                                            )
                                                      ) +
                                                      " * "
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "120px",
                                                    },
                                                    model: {
                                                      value: scope.row.taxRate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "taxRate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.taxRate",
                                                    },
                                                  }),
                                                  _vm._v(" % "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                "margin-left": "20px",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.MinimumStandards"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "120px",
                                                    },
                                                    model: {
                                                      value: scope.row.price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.price",
                                                    },
                                                  }),
                                                  _vm._v(" BRL "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 1
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "feeTypeList." +
                                                    scope.$index +
                                                    ".taxRate",
                                                  rules: {
                                                    required: true,
                                                    suffix: 2,
                                                    negative: "",
                                                    validator: _vm.priceType,
                                                    trigger: ["blur", "change"],
                                                  },
                                                },
                                              },
                                              [
                                                _vm.formData.businessType === 0
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "（" +
                                                            _vm.$t(
                                                              "basicData.CourierFee"
                                                            ) +
                                                            " + " +
                                                            _vm.$t(
                                                              "basicData.CourierTax"
                                                            ) +
                                                            "(ISS/ICMS)" +
                                                            "（" +
                                                            _vm.$t(
                                                              "basicData.InsuranceIncluded"
                                                            ) +
                                                            "））"
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.formData.businessType === 1
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "（" +
                                                            _vm.$t(
                                                              "basicData.CollectFees"
                                                            ) +
                                                            " + " +
                                                            _vm.$t(
                                                              "basicData.CollectTaxes"
                                                            ) +
                                                            "(ISS/ICMS)" +
                                                            "（" +
                                                            _vm.$t(
                                                              "basicData.InsuranceIncluded"
                                                            ) +
                                                            "））"
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.formData.businessType === 2
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "（" +
                                                            _vm.$t(
                                                              "basicData.DeliveryFee"
                                                            ) +
                                                            " + " +
                                                            _vm.$t(
                                                              "basicData.DeliveryTax"
                                                            ) +
                                                            "(ISS/ICMS)" +
                                                            "（" +
                                                            _vm.$t(
                                                              "basicData.InsuranceIncluded"
                                                            ) +
                                                            "））"
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" * "),
                                                _c("el-input", {
                                                  staticStyle: {
                                                    display: "inline-block",
                                                    width: "120px",
                                                  },
                                                  model: {
                                                    value: scope.row.taxRate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "taxRate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.taxRate",
                                                  },
                                                }),
                                                _vm._v(" % "),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.row.specialRules === 2
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRateOne",
                                                  },
                                                },
                                                [
                                                  _vm.formData.businessType ===
                                                  0
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.CourierFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  1
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "basicData.CollectFees"
                                                              ) +
                                                                " + " +
                                                                _vm.$t(
                                                                  "basicData.insurance"
                                                                )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  2
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.DeliveryFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " / (1 - ISS" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "GlobalSetObj.rate"
                                                        )
                                                      ) +
                                                      ") "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" * "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRate",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " ISS" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "GlobalSetObj.rate"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 3
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRateOne",
                                                  },
                                                },
                                                [
                                                  _vm.formData.businessType ===
                                                  0
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.CourierFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  1
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "basicData.CollectFees"
                                                              ) +
                                                                " + " +
                                                                _vm.$t(
                                                                  "basicData.insurance"
                                                                )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  2
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.DeliveryFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " / (1 - ICMS" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "GlobalSetObj.rate"
                                                        )
                                                      ) +
                                                      ") * ICMS" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "GlobalSetObj.rate"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 4
                                      ? _c("div", [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "feeTypeList." +
                                                        scope.$index +
                                                        ".weight",
                                                      rules: {
                                                        required: true,
                                                        suffix: 3,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "operationCenter.Weight"
                                                          )
                                                        ) +
                                                        " >= "
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "120px",
                                                      },
                                                      model: {
                                                        value: scope.row.weight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "weight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.weight",
                                                      },
                                                    }),
                                                    _vm._v(" KG "),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  "margin-left": "20px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "feeTypeList." +
                                                        scope.$index +
                                                        ".price",
                                                      rules: {
                                                        required: true,
                                                        suffix: 2,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "basicData.IncreaseThePrice"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "120px",
                                                      },
                                                      model: {
                                                        value: scope.row.price,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "price",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.price",
                                                      },
                                                    }),
                                                    _vm._v(" BRL "),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 5
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".weight",
                                                    rules: {
                                                      required: true,
                                                      suffix: 3,
                                                      negative: "",
                                                      validator: _vm.priceType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "120px",
                                                    },
                                                    model: {
                                                      value: scope.row.weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.weight",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " /KG（" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.roundUp"
                                                        )
                                                      ) +
                                                      "） "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                "margin-left": "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".price",
                                                    rules: {
                                                      required: true,
                                                      suffix: 2,
                                                      negative: "",
                                                      validator: _vm.priceType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.increase"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "120px",
                                                    },
                                                    model: {
                                                      value: scope.row.price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.price",
                                                    },
                                                  }),
                                                  _vm._v(" BRL "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 6
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "feeTypeList." +
                                                    scope.$index +
                                                    ".price",
                                                  rules: {
                                                    required: true,
                                                    suffix: 2,
                                                    negative: "",
                                                    validator: _vm.priceType,
                                                    trigger: ["blur", "change"],
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    display: "inline-block",
                                                    width: "120px",
                                                  },
                                                  model: {
                                                    value: scope.row.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.price",
                                                  },
                                                }),
                                                _vm._v(
                                                  " /" +
                                                    _vm._s(
                                                      _vm.$t("basicData.ticket")
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.row.specialRules === 7
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRateOne",
                                                  },
                                                },
                                                [
                                                  _vm.formData.businessType ===
                                                  0
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.CourierFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  1
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "basicData.CollectFees"
                                                              ) +
                                                                " + " +
                                                                _vm.$t(
                                                                  "basicData.insurance"
                                                                )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.formData.businessType ===
                                                  2
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "basicData.DeliveryFee"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " * ISS" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "GlobalSetObj.rate"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 8
                                      ? _c("div", [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "feeTypeList." +
                                                        scope.$index +
                                                        ".weight",
                                                      rules: {
                                                        required: true,
                                                        suffix: 3,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "operationCenter.Weight"
                                                          )
                                                        ) +
                                                        " > "
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "120px",
                                                      },
                                                      model: {
                                                        value: scope.row.weight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "weight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.weight",
                                                      },
                                                    }),
                                                    _vm._v(" KG "),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  "margin-left": "20px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "feeTypeList." +
                                                        scope.$index +
                                                        ".price",
                                                      rules: {
                                                        required: true,
                                                        suffix: 2,
                                                        negative: "",
                                                        validator:
                                                          _vm.priceType,
                                                        trigger: [
                                                          "blur",
                                                          "change",
                                                        ],
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "basicData.IncreaseThePrice"
                                                          )
                                                        ) +
                                                        "/KG "
                                                    ),
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "120px",
                                                      },
                                                      model: {
                                                        value: scope.row.price,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "price",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.price",
                                                      },
                                                    }),
                                                    _vm._v(" BRL "),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 10
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "feet-r" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".ruleType",
                                                    rules: {
                                                      required: true,
                                                      message: _vm.$t(
                                                        "basicData.CannotBeEmpty"
                                                      ),
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        display: "inline-block",
                                                        width: "160px",
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "basicData.InsuranceType"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.ruleType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "ruleType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.ruleType",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.insuranceTypeList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.dictValue,
                                                          attrs: {
                                                            label:
                                                              item.dictLabel,
                                                            value:
                                                              item.dictValue,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "placeOrder.InvoiceAmount"
                                                    )
                                                  ) +
                                                  " * "
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRate",
                                                    rules: {
                                                      required: true,
                                                      suffix: 2,
                                                      negative: "",
                                                      validator: _vm.ratioType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "120px",
                                                    },
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "orderCenterCont.proportions"
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.taxRate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "taxRate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.taxRate",
                                                    },
                                                  }),
                                                  _vm._v(" % "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 11
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "feet-r" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("basicData.Volume")
                                                  ) +
                                                  " * "
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".price",
                                                    rules: {
                                                      required: true,
                                                      suffix: 2,
                                                      negative: "",
                                                      validator: _vm.priceType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "basicData.PleaseEnterTheUnitPrice"
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.price",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("span", [_vm._v("m^3")]),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 12
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "feet-r" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderDeclaredValue"
                                                    )
                                                  ) +
                                                  " * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderFreight"
                                                    )
                                                  ) +
                                                  " * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderII"
                                                    )
                                                  ) +
                                                  " * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderICMS"
                                                    )
                                                  ) +
                                                  ") * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "basicData.exchangeRate"
                                                    )
                                                  ) +
                                                  " * "
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRate",
                                                    rules: {
                                                      required: true,
                                                      suffix: 2,
                                                      negative: "",
                                                      validator: _vm.ratioType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "basicData.pleaseEnterValue"
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.taxRate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "taxRate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.taxRate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("span", [_vm._v("%")]),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.specialRules === 13
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "feet-r" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderDeclaredValue"
                                                    )
                                                  ) +
                                                  " * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderFreight"
                                                    )
                                                  ) +
                                                  " * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "receivablePayable.CrossBorderOrderInsurance"
                                                    )
                                                  ) +
                                                  ") * " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "basicData.exchangeRate"
                                                    )
                                                  ) +
                                                  " * "
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "feeTypeList." +
                                                      scope.$index +
                                                      ".taxRate",
                                                    rules: {
                                                      required: true,
                                                      suffix: 2,
                                                      negative: "",
                                                      validator: _vm.ratioType,
                                                      trigger: [
                                                        "blur",
                                                        "change",
                                                      ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      display: "inline-block",
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "basicData.pleaseEnterValue"
                                                      ),
                                                    },
                                                    model: {
                                                      value: scope.row.taxRate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "taxRate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.taxRate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("span", [_vm._v("%")]),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.operate"),
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: {
                                        title: _vm.$t(
                                          "basicData.AreYouSureYouWantToDelete"
                                        ),
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.handleDel(
                                            scope.$index,
                                            "feeTypeList"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "danger",
                                          },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("basicData.Delete"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "permit",
              rawName: "v-permit:remove",
              value: "btn:finance:basicData:quotationManagement:edit",
              expression: "'btn:finance:basicData:quotationManagement:edit'",
              arg: "remove",
            },
          ],
          staticClass: "addFooter",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.handleUpdatePage(false)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submitForm },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("basicData.tips"),
            visible: _vm.dialogVisible,
            width: "400",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm._l(_vm.errData, function (item, ind) {
            return _c(
              "div",
              {
                key: ind,
                staticStyle: { color: "red", "margin-bottom": "8px" },
              },
              [_vm._v(_vm._s(item))]
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("DiscountDiaLog", {
        ref: "discountDiaLog",
        attrs: { ids: _vm.offerPriceId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }